export default async function openFile(
    description: string,
    accept: Record<string, string[]>
) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [fileHandle] = await (window as any).showOpenFilePicker({
        types: [
            {
                description,
                accept,
            },
        ],
    });
    const file = await fileHandle?.getFile();
    return new Promise<string>((res, rej) => {
        const reader = new FileReader();
        reader.onerror = rej;
        reader.onabort = rej;
        reader.onload = () => {
            try {
                res(reader.result as string);
            } catch (e) {
                rej(e);
            }
        };
        reader.readAsText(file);
    });
}
